import Radium from "radium";
import React from "react";

import { styles } from "@common/styles";
import { formatDate } from "@common";
import { IApiKey } from "@common/models";

export interface IApiKeyListItemProps {
  apiKey: IApiKey;
  editApiKey: (apikey: IApiKey) => void;
}

class ApiKeyListItem extends React.Component<IApiKeyListItemProps, any> {
  public render() {
    const { apiKey } = this.props;
    return (
      <div style={{ display: "flex", marginBottom: "10px" }}>
        <div style={{ display: "flex", flex: "2" }}>
          {apiKey.tokenName}
          <span style={styles.subItemInfo}>
            &nbsp;(utløper {formatDate(apiKey.createdDate)})
          </span>
        </div>
        <div
          onClick={() => this.props.editApiKey(apiKey)}
          style={styles.listLinkStyle}
        >
          Rediger
        </div>
      </div>
    );
  }
}

export default Radium(ApiKeyListItem);
